export function getPickerTheme(isDark: boolean) {
  return {
    dialog: isDark
      ? 'border-zinc-700 bg-card'
      : 'border-[#e8e4d8] bg-white',
    header: isDark
      ? 'bg-card'
      : 'bg-gradient-to-b from-[#fff7b8] to-white',
    title: isDark ? 'text-foreground' : 'text-[#171b23]',
    subtitle: isDark ? 'text-muted-foreground' : 'text-[#565f6b]',
    close: isDark
      ? 'text-muted-foreground hover:bg-white/10 hover:text-foreground'
      : 'text-[#565f6b] hover:bg-black/5 hover:text-[#171b23]',
    searchIcon: isDark ? 'text-muted-foreground' : 'text-[#8b8a84]',
    search: isDark
      ? 'border-zinc-700 bg-white/[0.04] text-foreground placeholder:text-muted-foreground focus:border-zinc-600 focus:bg-white/[0.07]'
      : 'border-[#e8e4d8] bg-[#faf9f5] text-[#171b23] placeholder:text-[#8b8a84] focus:border-[#171b23] focus:bg-white',
    field: isDark ? 'border-zinc-700 bg-white/[0.04]' : 'border-[#e8e4d8] bg-[#faf9f5]',
    chipWrap: isDark ? 'border-zinc-700' : 'border-[#e8e4d8]',
    chip: isDark
      ? 'border border-zinc-700 bg-white/15 text-foreground hover:border-zinc-600 hover:bg-white/25'
      : 'border border-[#171b23] bg-[#171b23] text-white hover:bg-zinc-800',
    rowSelected: isDark
      ? 'border-zinc-600 bg-amber-400/[0.08]'
      : 'border-[#171b23] bg-[#fff7b8]/70',
    rowIdle: isDark
      ? 'border-zinc-700 bg-white/[0.04] hover:border-zinc-600 hover:bg-white/[0.07]'
      : 'border-[#e8e4d8] bg-[#faf9f5] hover:border-[#171b23]/30 hover:bg-white',
    iconSelected: isDark ? 'bg-amber-400/20 text-amber-100' : 'bg-[#171b23] text-white',
    iconIdle: isDark ? 'bg-white/10 text-foreground' : 'bg-white text-[#171b23]',
    pillSelected: isDark
      ? 'border border-zinc-600 bg-white text-black hover:bg-zinc-200 transition-colors'
      : 'border border-[#171b23] bg-[#171b23] text-white',
    pillRemove: isDark
      ? 'border border-zinc-700 bg-white/10 text-foreground hover:border-zinc-600 hover:bg-white/15 transition-colors'
      : 'border border-[#171b23] bg-[#171b23] text-white',
    pillIdle: isDark
      ? 'border border-zinc-700 bg-white/10 text-foreground hover:border-zinc-600 hover:bg-white/15 transition-colors'
      : 'border border-[#e8e4d8] bg-white text-[#171b23] hover:border-[#171b23]/30 transition-colors',
    emptyIcon: isDark ? 'bg-amber-400/15 text-amber-100' : 'bg-[#fff7b8] text-[#171b23]',
    footer: isDark ? 'border-zinc-700' : 'border-[#e8e4d8]',
    muted: isDark ? 'text-muted-foreground' : 'text-[#565f6b]',
    body: isDark ? 'text-foreground' : 'text-[#171b23]',
    tabList: isDark ? 'border-zinc-700 bg-white/[0.04]' : 'border-[#e8e4d8] bg-[#faf9f5]',
    tab: isDark
      ? 'data-[state=inactive]:!text-zinc-200 hover:bg-transparent'
      : 'text-muted-foreground hover:text-muted-foreground hover:bg-transparent',
    tabActive: isDark
      ? 'data-[state=active]:!bg-zinc-600 data-[state=active]:!text-white'
      : 'data-[state=active]:bg-[#171b23] data-[state=active]:text-white',
  };
}
